module.exports = __webpack_public_path__ + "static/img/Callum-Mills.9faa265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Callum-Mills.jpg
// module id = +jP7
// module chunks = 0